exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kba-modal-param{font-weight:bold}.kba-modal-external-id{font-family:'DroidSansMonoDotted'}.kba-modal-icon{opacity:.7;margin-right:.5rem}.kba-modal-vendor-logo{background-color:white;height:65px;padding:1rem;position:absolute;right:0px;top:0px}.kba-modal-warning-row{background-color:#d8473e4a !important}\n", ""]);

// exports
